export default "__VITE_ASSET__Ce6xwsNc__"